import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";

const AppRoute = ({
  component: Component,
  layout: Layout,
  isUserLogin,
  isAuthProtected,
  permission,
  permissions,
  isLogin,
  ...rest
}) => {

  const hasPermission = (permissions) =>
    permissions.some((permission) => permissions.includes(permission));

  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthProtected && !localStorage.getItem("authUser")) {
          return (
            <>
              <Redirect
                to={{ pathname: "/login", state: { from: props.location } }}
              />
            </>
          );
        }
        // if (!permissions) {
        //   return <>123</>;
        // } else if (!permissions[permission])
        //   return (
        //     <Redirect
        //       to={{ pathname: "/dashboard", state: { from: props.location } }}
        //     />
        //   );

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
};

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
  isUserLogin: PropTypes.bool,
  permissions: PropTypes.any,
  permission: PropTypes.any,
  isLogin: PropTypes.any,
};

export default AppRoute;
